module.exports = "/dog-racing/img/btn-background-green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/btn-background-green.png
// module id = 266
// module chunks = 7